export default function Tech({ tech }) {
    return (
        <li className="projects__tech-item">{tech}</li>
    )
}